// Disabled Beamer
// import { reactQueryClient } from '../../../clients/api/client';
// import { CurrentUserQueryKeys } from '../../../clients/api/entities/current-user/current-user-api';
import { getFirstChannelForHouseId } from '../../channelList/channelListSelectors';
import { getSelectedChannelId } from '../../channels/channelsSelectors';
import changeSelectedChannelId from '../../channels/channelsThunks/changeSelectedChannelId';
import { resetNewChannelOptions } from '../../newChannelOptions/newChannelOptionsSlice';
import { selectedHouseIdChanged } from '../housesSlice';

const changeSelectedHouseId =
  ({ selectedHouseId }) =>
  async (dispatch, getState) => {
    const selectedChannelId = getSelectedChannelId(getState());
    const nextChannel = getFirstChannelForHouseId(selectedHouseId)(getState());

    if (nextChannel && nextChannel !== selectedChannelId) {
      dispatch(changeSelectedChannelId({ selectedChannelId: nextChannel }));
    }

    dispatch(selectedHouseIdChanged({ selectedHouseId }));
    dispatch(resetNewChannelOptions());

    // Disabled Beamer
    // The beamer channel's presence/flag state depends on the house, so it needs to be
    // re-evaluated whenever the user switches houses. Invalidated here explicitly (on the
    // user-initiated action) instead of via a useEffect watching selectedHouseId, since that
    // reactive approach was prone to firing on unrelated re-renders/remounts.
    // reactQueryClient.invalidateQueries({
    //   queryKey: [CurrentUserQueryKeys.GET_BEAMER_CHANNEL, selectedHouseId],
    //   exact: false,
    // });
  };

export default changeSelectedHouseId;
